export const AGENT_UPLOAD_DATA_PART_NAME = "agent-upload";

export const AGENT_UPLOAD_MARKER_PREFIX = "agent-upload:";

export { AGENT_UPLOADED_FILES_METADATA_KEY } from "@/agents-v2/message-metadata/metadata-only-message";
